module.exports = __webpack_public_path__ + "static/media/move_camera_off.ed74e4a7.svg";